<template>
  <v-row>
    <v-col :cols="labelCols" class="py-0">
      <div v-if="label">
        {{ label }}:
      </div>
    </v-col>
    <v-col class="py-0">
      <slot>
        <div :class="valuesClass" v-for="(value, idx) in values" :key="idx">
          {{ value }}
        </div>
      </slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AnchorAttributeDisplay',
  props: {
    label: String,
    values: Array,
    valuesClass: String,
    labelCols: {
      type: [Number, String],
      default: 6,
    },
  },
};
</script>
